import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/required-uuid-string.js';
import { leafLinkWebhookSettingField } from './leaflink-webhook-setting-field.js';
export const setLeafLinkWebhookSettingsArgsSchema = z.object({
    leafLinkIntegrationId: requiredUuidString('LeafLink company is required.', 'Invalid LeafLink company.'),
    serviceUserId: leafLinkWebhookSettingField('serviceUserId', 'Invalid service user.'),
    defaultLocationGroupId: leafLinkWebhookSettingField('defaultLocationGroupId', 'Invalid location group.'),
    defaultCarrierId: leafLinkWebhookSettingField('defaultCarrierId', 'Invalid carrier.'),
    defaultFobPointId: leafLinkWebhookSettingField('defaultFobPointId', 'Invalid FOB point.'),
});
//# sourceMappingURL=set-leaflink-webhook-settings-args-schema.js.map